module.exports = __webpack_public_path__ + "img/126.960a0040.jpg";